import React from 'react';
import { Hotel, Plane, Shield, Ticket, Car, Wrench, ArrowRight } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  description: string;
  buttonText: string;
  icon: React.ElementType;
  imageUrl: string;
  imageAlt: string;
}
function ServiceCard({
  title,
  description,
  buttonText,
  icon: Icon,
  imageUrl,
  imageAlt
}: ServiceCardProps) {
  return <div className="group relative bg-white border border-gray-200 rounded-lg overflow-hidden hover:border-[#4b5563] transition-all duration-300 hover:scale-[1.02] hover:shadow-md" data-id="element-146">
      {/* Image */}
      <div className="aspect-[3/2] w-full overflow-hidden relative bg-gray-100" data-id="element-147">
        <img src={imageUrl} alt={imageAlt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={e => {
        const target = e.target as HTMLImageElement;
        target.src = 'https://picsum.photos/800/533?grayscale';
      }} data-id="element-148" />
        <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm p-2 rounded-full" data-id="element-149">
          <Icon className="h-5 w-5 text-[#4b5563]" data-id="element-150" />
        </div>
      </div>

      <div className="p-6" data-id="element-151">
        <h3 className="text-xl font-bold text-[#1f2933] mb-2" data-id="element-152">{title}</h3>
        <p className="text-gray-500 mb-6 text-sm" data-id="element-153">{description}</p>
        <button className="w-full py-3 px-4 border border-gray-300 rounded text-[#1f2933] font-medium hover:bg-[#1f2933] hover:text-white transition-colors flex items-center justify-center group-hover:border-[#1f2933]" data-id="element-154">
          {buttonText} <ArrowRight className="ml-2 h-4 w-4" data-id="element-155" />
        </button>
      </div>
    </div>;
}
export function ServiceCategoryCards() {
  const services = [{
    title: 'Hotels & Stays',
    description: 'Luxury hotels and resorts worldwide with exclusive perks.',
    buttonText: 'Book Stays',
    icon: Hotel,
    imageUrl: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80&auto=format&fit=crop',
    imageAlt: 'Luxury resort with infinity pool'
  }, {
    title: 'Flights',
    description: 'Best deals on business and first-class flights to any destination.',
    buttonText: 'Search Flights',
    icon: Plane,
    imageUrl: 'https://images.unsplash.com/photo-1569154941061-e231b4725ef1?w=800&q=80&auto=format&fit=crop',
    imageAlt: 'Airplane wing view above the clouds'
  }, {
    title: 'Travel Insurance',
    description: 'Comprehensive coverage for peace of mind on every journey.',
    buttonText: 'Get Insurance',
    icon: Shield,
    imageUrl: 'https://images.unsplash.com/photo-1450101499163-c8848e968838?w=800&q=80&auto=format&fit=crop',
    imageAlt: 'Travel insurance and safety protection'
  }, {
    title: 'Tickets & Attractions',
    description: 'Theme parks, guided tours, and exclusive local experiences.',
    buttonText: 'Explore Tickets',
    icon: Ticket,
    imageUrl: 'https://images.unsplash.com/photo-1536768139911-e290a59011e4?w=800&q=80&auto=format&fit=crop',
    imageAlt: 'People enjoying a theme park roller coaster'
  }, {
    title: 'Rent a Car Anywhere',
    description: 'Affordable car rentals worldwide for total travel freedom.',
    buttonText: 'Rent a Car',
    icon: Car,
    imageUrl: 'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=800&q=80&auto=format&fit=crop',
    imageAlt: 'Car rental on a scenic road'
  }, {
    title: 'Easy & Cheap Transfers Worldwide',
    description: 'Affordable airport transfers and transportation anywhere in the world.',
    buttonText: 'Book Transfer',
    icon: Wrench,
    imageUrl: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=800&q=80&auto=format&fit=crop',
    imageAlt: 'Airport taxi transfer service'
  }];
  return <section id="services" className="py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-156">
      <div className="max-w-7xl mx-auto" data-id="element-157">
        <div className="text-center mb-16" data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1f2933] mb-4" data-id="element-159">
            All Our Favorite Links Down Below!
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto" data-id="element-160">
            Everything you need for a perfect trip, all in one place.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-161">
          {services.map((service, index) => <ServiceCard key={index} title={service.title} description={service.description} buttonText={service.buttonText} icon={service.icon} imageUrl={service.imageUrl} imageAlt={service.imageAlt} data-id="element-162" />)}
        </div>
      </div>
    </section>;
}